import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBatteryError: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBatteryError"><Path d="M12.25 9.75L10 12M10 12L7.75 14.25M10 12L7.75 9.75M10 12L12.25 14.25M1.5 5.5H19.5V18.5H1.5V5.5ZM19.5 8.5H22.5V15.5H19.5V8.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconBatteryError;
